import createLucideIcon from '../createLucideIcon';

const AlertCircle = createLucideIcon('AlertCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '12', y1: '8', x2: '12', y2: '12', key: '1grbh0' }],
  ['line', { x1: '12', y1: '16', x2: '12.01', y2: '16', key: '1w440g' }],
]);

export default AlertCircle;
